import { Avatar } from 'flowbite-react';
import React from 'react';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { FaChevronRight } from 'react-icons/fa6';
import { HiOutlineMail } from 'react-icons/hi';
import { Img } from 'react-image';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { checkDisplayUserEmail, stringAvatar } from 'shared-utils';
import { signout } from 'src/apis/auth';
import { STUDENT_APP_ENDPOINT } from 'src/config/env.config';
import { useLayoutContext } from 'src/context/LayoutProvider';
import { useUserContext } from 'src/context/UserProvider';
import { UserExperienceLevelType } from 'types';

const MoreOptions = () => {
	const { user } = useUserContext();
	const { onDeleteUserModalOpen } = useLayoutContext();
	const navigate = useNavigate();
	const { setShowUpdateRoleModal } = useUserContext();
	const signoutFn = useMutation(['signout'], signout, {
		onSuccess() {
			window.open(`${STUDENT_APP_ENDPOINT}/auth/signin`, '_self');
		},
	});

	// Options List
	const middleSctionOptions = [
		{
			isHidden: user?.userPreference?.experienceLevel === UserExperienceLevelType.FINAL_YEAR_STUDENT,
			optionName: 'Jobs',
			onClick: () => {
				navigate('/my-applications');
			},
		},
		// {
		// 	optionName: 'Interviews',
		// 	onClick: () => {
		// 		navigate('/interviews');
		// 	},
		// },
		// {
		// 	optionName: 'Offline Drive Opportunities',
		// 	onClick: () => {
		// 		navigate('/offline-drive-day-opportunities');
		// 	},
		// },
		// {
		// 	optionName: 'Refer & Earn',
		// 	onClick: () => {
		// 		navigate('/refer');
		// 	},
		// },
	];
	const bottomSectionOptions = [
		{
			optionName: 'Support',
			onClick: () => {
				navigate('/support');
			},
		},
		// {
		// 	optionName: 'How LevelUp Works?',
		// 	onClick: () => {
		// 		window.open(`${WEBSITE_URL}/how-levelup-works`, '_blank');
		// 	},
		// },
		// {
		// 	optionName: 'Technical round guildlines',
		// 	onClick: () => {
		// 		window.open(`${WEBSITE_URL}/how-levelup-works#interview-guidelines-section`, '_blank');
		// 	},
		// },
		// {
		// 	optionName: 'Support',
		// 	onClick: () => {
		// 		window.open(`${WEBSITE_URL}/support`, '_blank');
		// 	},
		// },
		// {
		// 	optionName: 'Delete Account',
		// 	onClick: () => {
		// 		onDeleteUserModalOpen();
		// 	},
		// },
		{
			optionName: 'Switch Role',
			onClick: () => {
				setShowUpdateRoleModal(true);
			},
			hide: user?.allowedRoles?.length && user?.allowedRoles?.length > 1 ? false : true,
		},

		{
			optionName: 'Logout',
			onClick: () => {
				signoutFn.mutate();
			},
		},
	];

	return (
		<div className="p-4 flex flex-col gap-4 items-center">
			{/* Top Section */}
			<div
				className="bg-white dark:bg-[#1F2A37] cursor-pointer w-full flex gap-2 items-center justify-between p-4 rounded-[8px] border dark:border-gray-700"
				onClick={() => {
					navigate(`/profile/${user?.handler}`);
				}}
			>
				<div className="flex gap-2">
					<div className="flex items-start pt-1">
						<Avatar
							img={user?.profile.profileImageUrl || user?.profile.imageUrl}
							alt="user-profile-pic"
							placeholderInitials={stringAvatar(user?.name || '')}
							rounded
							className="profile-avatar-in-more-option-page object-contain"
						/>
					</div>
					<div className="font-inter gap-1 flex flex-col items-start">
						<p className="font-[600] text-[20px]">{user?.name}</p>
						<p className="flex gap-1 items-center justify-center text-gray-700 dark:text-[#E4E4EB] text-[14px]">
							<BsFillTelephoneFill color="#A9EFF2" /> <span>{user?.phone}</span>
						</p>
						{user?.subRole === 'Onwards' && checkDisplayUserEmail(user) ? (
							<p className="flex gap-1 items-center justify-center text-gray-700 dark:text-[#E4E4EB] text-[14px]">
								<HiOutlineMail color="#A9EFF2" />
								<span className="truncate max-w-[186px]">{user?.email}</span>
							</p>
						) : null}
					</div>
				</div>
				<div>
					<FaChevronRight color="#7777E7" size={20} />
				</div>
			</div>

			{/* Middle Section */}
			<div className="bg-white dark:bg-[#1F2A37] py-[24px] px-[12px] flex flex-col gap-2 w-full rounded-[8px] border dark:border-gray-700">
				{middleSctionOptions
					?.filter(option => !option.isHidden)
					.map((option, i) => {
						return (
							<div
								key={i}
								className="hover:bg-gray-100 dark:hover:bg-[#18222D] items-center cursor-pointer w-full flex justify-between rounded-[8px] py-[8px] px-[12px] dark:hover:text-[#73DFE7]"
								onClick={option.onClick}
							>
								<div className="flex gap-3 items-center">
									<div>{option.optionName} </div>
									{option.optionName === 'Refer & Earn' && (
										<div className="border-[1px] rounded-[40px] border-[#E57A00] gap-1 px-[7px] py-[1px] flex">
											<Img
												src="/assets/level-up-coins.svg"
												alt="coin-logo"
												width="12"
												height={'12'}
												className="object-contain"
											/>
											<span className="text-[12px]">{user?.evaluation.levelCoins ?? 0}</span>
										</div>
									)}
								</div>
								<div>
									<FaChevronRight color="#7777E7" size={20} />
								</div>
							</div>
						);
					})}
			</div>

			{/* Bottom Section */}
			<div className="bg-white dark:bg-[#1F2A37] cursor-pointer py-[24px] px-[12px] flex flex-col gap-2 w-full rounded-[8px] border dark:border-gray-700">
				{bottomSectionOptions.map((option, i) => {
					if (option.hide) {
						return null;
					}
					return (
						<div
							key={i}
							className="hover:bg-gray-100 dark:hover:bg-[#18222D] w-full flex justify-between rounded-[8px] py-[8px] px-[12px] dark:hover:text-[#73DFE7]"
							onClick={option.onClick}
						>
							<div>{option.optionName}</div>
							<div>
								<FaChevronRight color="#7777E7" size={20} />
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default MoreOptions;
